/*
  Quick JS by Jason @ freakdesign.
  Adaptado para calcular e mostrar prazos de entrega em formato:
  "Seu pedido chegará em até X dias úteis"


  Reescrito em vanilla JS — não depende mais de jQuery nem jquery.mask.

  PARA INSTALAR: <script src="{{ 'quickShipping.js' | asset_url }}" defer></script>
*/

(function () {
    'use strict';

    var debug = false;
    /** @type {string} */
    var cartCookie = '';

    /** @param {string} text */
    function log(text) {
        if (!debug) return;
        console.log(text);
    }

    /**
     * Aplica máscara de CEP "00.000-000" enquanto o usuário digita
     * @param {HTMLInputElement} input
     */
    function applyCepMask(input) {
        input.addEventListener('input', function () {
            var v = input.value.replace(/\D/g, '').slice(0, 8);
            var out = v;
            if (v.length > 5) {
                out = v.slice(0, 2) + '.' + v.slice(2, 5) + '-' + v.slice(5);
            } else if (v.length > 2) {
                out = v.slice(0, 2) + '.' + v.slice(2);
            }
            input.value = out;
        });
    }

    /* Processa cada elemento de frete */
    function initQuickShippingForContainer(container) {
        if (container.classList.contains('qs-initialized')) return;
        container.classList.add('qs-initialized');

        /* Encontrar select de variação do produto no escopo global */
        var productSelect = document.querySelector('.product-variant-id');
        if (!productSelect) {
            productSelect = document.getElementsByName('id')[0];
        }
        var isCart = !productSelect;

        /* Cria os campos de frete */
        var shippingMessage = document.createElement('p');
        var shippingCountry = document.createElement('select');
        var shippingProvince = document.createElement('select');
        var shippingZip = document.createElement('input');
        var freteLista = document.createElement('div');

        /* Ajustes visuais */
        shippingMessage.classList.add('erros-fretes');
        shippingMessage.style.display = 'none';

        freteLista.classList.add('listas-de-fretes');
        freteLista.style.display = 'none';

        shippingCountry.style.display = 'none';
        var countries = ['Brazil'];
        for (var i = 0; i < countries.length; i++) {
            shippingCountry.add(new Option(countries[i], countries[i], i === 0));
        }
        shippingCountry.name = 'shipping_address[country]';

        shippingProvince.style.display = 'none';
        var provinces = [
            'Acre', 'Alagoas', 'Amapa', 'Amazonas', 'Bahia', 'Ceara',
            'Distrito Federal', 'Espirito Santo', 'Goias', 'Maranhao',
            'Mato Grosso', 'Mato Grosso do Sul', 'Minas Gerais', 'Para',
            'Paraiba', 'Parana', 'Pernambuco', 'Piaui', 'Rio de Janeiro',
            'Rio Grande do Norte', 'Rio Grande do Sul', 'Rondonia', 'Roraima',
            'Santa Catarina', 'Sao Paulo', 'Sergipe', 'Tocantins',
        ];
        for (var j = 0; j < provinces.length; j++) {
            shippingProvince.add(new Option(provinces[j], provinces[j], j === 0));
        }
        shippingProvince.name = 'shipping_address[province]';

        shippingZip.type = 'text';
        shippingZip.name = 'shipping_address[zip]';
        shippingZip.className = 'Form__Input cep-calculo-frete form-control';
        shippingZip.placeholder = 'DIGITE SEU CEP';
        shippingZip.inputMode = 'numeric';
        shippingZip.autocomplete = 'postal-code';
        shippingZip.maxLength = 10;
        applyCepMask(shippingZip);

        var shippingCalcWrapper = document.createElement('div');
        shippingCalcWrapper.className = 'shipping-calc-wrapper';

        var formularioFrete = document.createElement('div');
        formularioFrete.className = 'formulario-frete';

        var shippingCalcButton = document.createElement('a');
        shippingCalcButton.innerText = 'Calcular';
        shippingCalcButton.className = 'btn btn-underline button--primary button';
        shippingCalcButton.href = 'javascript:void(0)';
        shippingCalcButton.onclick = function () {
            var cepLimpo = shippingZip.value.replace(/\D/g, '');
            shippingMessage.innerHTML = '';
            shippingMessage.style.display = 'none';

            if (cepLimpo.length !== 8) {
                shippingMessage.innerHTML = 'CEP inválido. Digite os 8 dígitos.';
                shippingMessage.style.display = 'flex';
                return false;
            }

            fetch('https://viacep.com.br/ws/' + cepLimpo + '/json/')
                .then(function (res) {
                    if (!res.ok) throw new Error('viacep_http_' + res.status);
                    return res.json();
                })
                .then(function (dados) {
                    if (dados && !('erro' in dados)) {
                        var ufMap = {
                            AC: 'Acre', AL: 'Alagoas', AP: 'Amapa', AM: 'Amazonas',
                            BA: 'Bahia', CE: 'Ceara', DF: 'Distrito Federal',
                            ES: 'Espirito Santo', GO: 'Goias', MA: 'Maranhao',
                            MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais',
                            PA: 'Para', PB: 'Paraiba', PR: 'Parana', PE: 'Pernambuco',
                            PI: 'Piaui', RJ: 'Rio de Janeiro', RN: 'Rio Grande do Norte',
                            RS: 'Rio Grande do Sul', RO: 'Rondonia', RR: 'Roraima',
                            SC: 'Santa Catarina', SP: 'Sao Paulo', SE: 'Sergipe',
                            TO: 'Tocantins',
                        };
                        if (ufMap[dados.uf]) dados.uf = ufMap[dados.uf];

                        shippingProvince.value = dados.uf;

                        if (isCart) {
                            getRates();
                            return;
                        }

                        if (productSelect && !productSelect.value.length) {
                            console.log('Nenhuma variação selecionada');
                        }
                        cartCookie = getCookie('cart') || '';
                        var tempCookieValue = 'temp-cart-cookie___' + Date.now();
                        var fakeCookieValue = 'fake-cart-cookie___' + Date.now();

                        if (!cartCookie) {
                            log('sem cookie, criando');
                            updateCartCookie(tempCookieValue);
                            cartCookie = getCookie('cart') || '';
                        }

                        if (cartCookie.length < 32) {
                            log('cookie inválido');
                            return;
                        }

                        updateCartCookie(fakeCookieValue);

                        if (productSelect && !productSelect.value.length) {
                            var firstOption = productSelect.querySelectorAll('option')[1];
                            if (firstOption) getRates(parseInt(firstOption.value, 10));
                        } else if (productSelect) {
                            getRates(parseInt(productSelect.value, 10));
                        }
                        return;
                    }
                    throw new Error('viacep_not_found');
                })
                .catch(function () {
                    freteLista.innerHTML = '';
                    shippingMessage.innerHTML = 'Cep não encontrado, tente novamente.';
                    shippingMessage.style.display = 'flex';
                });

            return false;
        };

        formularioFrete.appendChild(shippingCountry);
        formularioFrete.appendChild(shippingProvince);
        formularioFrete.appendChild(shippingZip);
        formularioFrete.appendChild(shippingCalcButton);

        shippingCalcWrapper.appendChild(formularioFrete);
        shippingCalcWrapper.appendChild(shippingMessage);
        shippingCalcWrapper.appendChild(freteLista);

        container.appendChild(shippingCalcWrapper);

        /* Buscar valores de frete */
        var getRates = function (variantId) {
            freteLista.innerHTML = '';
            freteLista.style.display = '';

            if (!isCart && typeof variantId === 'undefined') return;

            var fetchRatesAjax = function () {
                freteLista.innerHTML =
                    "<img id='loading-icon-frete' src='https://cdn.shopify.com/s/files/1/0698/5852/5417/files/loading-buffering.webp' width='30px' style='width:30px; height: 30px; margin:0 auto'>";

                var params = new URLSearchParams({
                    'shipping_address[country]': shippingCountry.value,
                    'shipping_address[province]': shippingProvince.value,
                    'shipping_address[zip]': shippingZip.value,
                });

                fetch('/cart/shipping_rates.json?' + params.toString(), {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: { Accept: 'application/json' },
                })
                    .then(function (res) {
                        if (!res.ok) throw new Error('rates_http_' + res.status);
                        return res.json();
                    })
                    .then(function (d) {
                        if (d.shipping_rates && d.shipping_rates.length) {
                            var html = '';
                            for (var k = 0; k < d.shipping_rates.length; k++) {
                                var rate = d.shipping_rates[k];
                                var entrega;

                                if (rate.delivery_date != null) {
                                    entrega = formatarDataEntrega(rate.delivery_date);
                                } else if (rate.description != null) {
                                    entrega = formatarDataEntrega(rate.description);
                                } else {
                                    entrega = 'Prazo de entrega indisponível';
                                }

                                var valorFrete = rate.price;
                                if (valorFrete === '0.00' || valorFrete == null) {
                                    valorFrete = 'Grátis';
                                }

                                html +=
                                    '<div class="frete-item">' +
                                    '<div>' +
                                    '<p class="m-0 nome-frete">' +
                                    '<b><span class="frete-item-head" style="font-size: 1.4rem; font-weight: 400;">' +
                                    escapeHtml(rate.name) +
                                    '</span></b>' +
                                    '<span class="estimativa-de-entrega">' +
                                    escapeHtml(entrega) +
                                    '</span>' +
                                    '</p>' +
                                    '</div>' +
                                    '<div class="frete-valor" style="font-size: 1.4rem; font-weight: 400;">' +
                                    'Valor: <b><span class="frete-item-head" style="font-weight: 400;"> R$' +
                                    escapeHtml(String(valorFrete)) +
                                    '</span></b>' +
                                    '</div>' +
                                    '</div>';
                            }
                            freteLista.innerHTML = html;
                        } else {
                            freteLista.innerHTML =
                                '<p>Opss, não encontramos fretes disponíveis para este cep, tente novamente.</p>';
                        }
                        if (!isCart) resetCartCookie();
                    })
                    .catch(function () {
                        if (!isCart) resetCartCookie();
                        freteLista.innerHTML = '';
                        shippingMessage.innerHTML = 'Cep não encontrado, tente novamente.';
                        shippingMessage.style.display = 'flex';
                    });
            };

            if (isCart) {
                fetchRatesAjax();
            } else {
                var productQuantity = document.getElementById('Quantity');
                var quantity = productQuantity ? parseInt(productQuantity.value, 10) : 1;
                var addData = { id: variantId, quantity: quantity };

                fetch('/cart/add.js', {
                    body: JSON.stringify(addData),
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'xmlhttprequest',
                    },
                    method: 'POST',
                })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function () {
                        fetchRatesAjax();
                    })
                    .catch(function (err) {
                        console.error(err);
                        resetCartCookie();
                    });
            }
        };
    }

    /* Cookies */
    var getCookie = function (name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length === 2) return parts.pop().split(';').shift();
    };

    var updateCartCookie = function (a) {
        var date = new Date();
        date.setTime(date.getTime() + 14 * 86400000);
        var expires = '; expires=' + date.toGMTString();
        document.cookie = 'cart=' + a + expires + '; path=/';
    };

    var resetCartCookie = function () {
        updateCartCookie(cartCookie);
    };

    /* Escape básico para evitar HTML injetado da API de frete */
    function escapeHtml(str) {
        if (str == null) return '';
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    /**
     * Calcula a quantidade de dias úteis entre a data atual e a data informada.
     * @param {Date} dataFim 
     * @returns {number}
     */
    function calcularDiasUteis(dataFim) {
        var hoje = new Date();
        hoje.setHours(0, 0, 0, 0);

        var fim = new Date(dataFim.getTime());
        fim.setHours(0, 0, 0, 0);

        if (fim <= hoje) return 1;

        var diasUteis = 0;
        var atual = new Date(hoje.getTime());

        while (atual < fim) {
            atual.setDate(atual.getDate() + 1);
            var diaSemana = atual.getDay();
            if (diaSemana !== 0 && diaSemana !== 6) {
                diasUteis++;
            }
        }
        return diasUteis > 0 ? diasUteis : 1;
    }

    /* Função para formatar data de entrega */
    function formatarDataEntrega(dataStr) {
        try {
            var dias = 0;
            var matchDate = dataStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
            if (matchDate) {
                var ano = parseInt(matchDate[1], 10);
                var mes = parseInt(matchDate[2], 10) - 1;
                var dia = parseInt(matchDate[3], 10);
                var data = new Date(ano, mes, dia);
                dias = calcularDiasUteis(data);
            } else if (/(\d+)/.test(dataStr)) {
                dias = parseInt(dataStr.match(/(\d+)/)[0], 10);
            }

            if (dias > 0) {
                var textoDia = dias === 1 ? 'dia útil' : 'dias úteis';
                return 'Seu pedido chegará em até ' + dias + ' ' + textoDia;
            }
            return dataStr;
        } catch (e) {
            console.error('Erro ao formatar data:', e);
            return dataStr;
        }
    }

    function initializeAllContainers() {
        var productSections = document.querySelectorAll('.frete-produto:not(.qs-initialized)');
        productSections.forEach(function (section) {
            initQuickShippingForContainer(section);
        });
    }

    // Inicializa imediatamente
    initializeAllContainers();

    // Observa mudanças no DOM para inicializar em drawers ou carregamentos ajax
    var observer = new MutationObserver(function () {
        if (document.querySelector('.frete-produto:not(.qs-initialized)')) {
            initializeAllContainers();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
})();